export default from './reg-items-discount-header'
